export function getCultureFromPage() {
  return document.querySelector('.js-culture-code').value;
}

export function getNodeIdFromPage() {
  return document.querySelector('.js-node-id').value;
}

export function getTwoLetterCountryCode() {
  const cultureCode = getCultureFromPage();

  return cultureCode.split('-')[1].toLowerCase();
}

export function getCached(key) {
  try {
    const json = sessionStorage.getItem(key);
    if (json === '' || json === null || json === undefined) {
      return false;
    }
    return JSON.parse(json);
  } catch (error) {
    // eslint-disable-next-line
    console.log('sessionstorage not supported');
    return null;
  }
}

export function setCached(key, object) {
  try {
    const json = JSON.stringify(object);
    sessionStorage.setItem(key, json);
  } catch (error) {
    // eslint-disable-next-line
    console.log('sessionstorage not supported');
  }
}

export function clearCache(key) {
  try {
    sessionStorage.removeItem(key);
  } catch (error) {
    // eslint-disable-next-line
    console.log('sessionstorage not supported');
  }
}

/**
 * Checks if the current client is IE.
 */
export function IsUsingIE() {
  /* eslint-disable */
  if (
    navigator.appName == 'Microsoft Internet Explorer' ||
    !!(navigator.userAgent.match(/Trident/) || navigator.userAgent.match(/rv:11/)) ||
    (typeof $.browser !== 'undefined' && $.browser.msie == 1)
  ) {
    return true;
  }
  /* eslint-enable */
  return false;
}

/**
 * Returns the given nodelist as an array of nodes
 * @param {NodeList} nodes
 */
export function nodeListToArray(nodes) {
  return Array.prototype.slice.call(nodes);
}

/**
 * @param {Object} object
 * @param {string} key
 * @return {any} value
 */
export function getParameterCaseInsensitive(object, key) {
  return object[Object.keys(object).find(k => k.toLowerCase() === key.toLowerCase())];
}

/**
 * Returns the first matched item in the array, if not found then it returns null
 * @param {Array} array
 * @param {Function} filterCondition
 */
export function firstOrDefault(array, filterCondition) {
  if (!Array.isArray(array)) {
    return null;
  }

  if (array.length === 0) {
    return null;
  }

  const results = array.filter(filterCondition);

  if (results.length === 0) {
    return null;
  }

  return results[0];
}

/* eslint-disable */
export function distance(lat1, lon1, lat2, lon2, unit) {
  if (lat1 == lat2 && lon1 == lon2) {
    return 0;
  } else {
    var radlat1 = (Math.PI * lat1) / 180;
    var radlat2 = (Math.PI * lat2) / 180;
    var theta = lon1 - lon2;
    var radtheta = (Math.PI * theta) / 180;
    var dist = Math.sin(radlat1) * Math.sin(radlat2) + Math.cos(radlat1) * Math.cos(radlat2) * Math.cos(radtheta);
    if (dist > 1) {
      dist = 1;
    }
    dist = Math.acos(dist);
    dist = (dist * 180) / Math.PI;
    dist = dist * 60 * 1.1515;
    if (unit == 'K') {
      dist = dist * 1.609344;
    }
    if (unit == 'N') {
      dist = dist * 0.8684;
    }
    return dist;
  }
}
/* eslint-enable */

/* eslint-disable */
// This is the decompiled jQuery getOffset() function
export function getOffset(element) {
  var docElem,
    win,
    rect,
    doc,
    elem = element;

  if (!elem) {
    return;
  }

  rect = elem.getBoundingClientRect();

  // Make sure element is not hidden (display: none) or disconnected
  if (rect.width || rect.height || elem.getClientRects().length) {
    doc = elem.ownerDocument;
    win = window;
    docElem = doc.documentElement;

    return {
      top: rect.top + win.pageYOffset - docElem.clientTop,
      left: rect.left + win.pageXOffset - docElem.clientLeft,
    };
  }
}
/* eslint-enable */

/** Groups the given array using the given expression */
export function groupBy(array, expression) {
  const map = new Map();
  Array.forEach(array, item => {
    const key = expression(item);
    const collection = map.get(key);
    if (!collection) {
      map.set(key, [item]);
    } else {
      collection.push(item);
    }
  });
  return map;
}

/**
 * Checks if the given rectangles intersect
 * @param rectA
 * @param rectB
 */
export function intersects(rectA, rectB) {
  return !(rectB.left >= rectA.right || rectB.right <= rectA.left || rectB.top >= rectA.bottom || rectB.bottom <= rectA.top);
}
